<template>
  <TFinderLayout>
    <template #actionbar>
      <div v-if="$vuetify.breakpoint.smAndDown /* TODO: show this only when in mobile */" class="account-view-actionbar">
        <TText value="On Site" />
        <ToggleCapsule
          :is_active="$store.state.View.on_site"
          knob_color="white"
          foreground_color="green"
          @toggleClicked="changeValue('on_site', 'On_Site')"
        />
      </div>
    </template>
    <template #sidebar>
      <div v-if="$vuetify.breakpoint.smAndUp" class="color-white-04">{{$t("Account.Account.Header")}}</div>

      <!-- AccountInvitations -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'AccountInvitations'
          })"
      >
        <!-- Selection Highlight -->
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'AccountInvitations'"
          class="account-view-sidebar-highlight"
        />

        <!-- Actual Option -->
        <div
          class="account-view-sidebar-option"
          :style="`padding-right: ${$vuetify.breakpoint.smAndUp ? 16 : 0}px;`"
        >
          <v-icon class="color-white-09 mr-1" :small="$vuetify.breakpoint.smAndUp">email</v-icon>
          <TText
            v-if="$vuetify.breakpoint.smAndUp"
            value="Invitations"
            font_weight="400"
            medium
          />
          <StandardBadge
            v-if="getProjectInvites.length !== 0"
            color="white"
            :text="getProjectInvites.length"
            content_color="black"
            :zoom="1"
          />
        </div>
      </TFlex>

      <!-- AccountInfo -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'AccountInfo'
          })"
      >
        <!-- Selection Highlight -->
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'AccountInfo'"
          class="account-view-sidebar-highlight"
        />

        <!-- Actual Option -->
        <div
          class="account-view-sidebar-option"
          :style="`padding-right: ${$vuetify.breakpoint.smAndUp ? 16 : 0}px;`"
        >
          <v-icon class="color-white-09 mr-1" :small="$vuetify.breakpoint.smAndUp">assignment_ind</v-icon>
          <TText
            v-if="$vuetify.breakpoint.smAndUp"
            value="Information"
            font_weight="400"
            medium
          />
        </div>
      </TFlex>

      <!-- AccountSettings -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'AccountSettings'
          })"
      >
        <!-- Selection Highlight -->
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'AccountSettings'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
        />

        <!-- Actual Option -->
        <div
          class="account-view-sidebar-option"
          :style="`padding-right: ${$vuetify.breakpoint.smAndUp ? 16 : 0}px;`"
        >
          <v-icon class="color-white-09 mr-1" :small="$vuetify.breakpoint.smAndUp">settings</v-icon>
          <TText
            v-if="$vuetify.breakpoint.smAndUp"
            value="Settings"
            font_weight="400"
            medium
          />
        </div>
      </TFlex>

      <!-- AccountMessages -->
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'AccountMessages'
          })"
      >
        <!-- Selection Highlight -->
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'AccountMessages'"
          class="account-view-sidebar-highlight"
        />

        <!-- Actual Option -->
        <div
          class="account-view-sidebar-option"
          :style="`padding-right: ${$vuetify.breakpoint.smAndUp ? 16 : 0}px;`"
        >
          <v-icon class="color-white-09 mr-1" :small="$vuetify.breakpoint.smAndUp">message</v-icon>
          <TText
            v-if="$vuetify.breakpoint.smAndUp"
            value="Messages"
            font_weight="400"
            medium
          />
          <!-- NOTE: hardcoded, remove this or get appropriate number -->
          <StandardBadge
            v-if="false"
            color="white"
            :text="2"
            content_color="black"
            :zoom="1"
          />
        </div>
      </TFlex>

      <!-- AccountClients -->
      <!-- <TFlex
        v-if="hasPermission('Client READ')"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'AccountClients'
          })"
      >
        Selection Highlight -->
        <!-- <div
          v-if="$route.matched[1] && $route.matched[1].name === 'AccountClients'"
          class="account-view-sidebar-highlight"
        /> -->

        <!-- Actual Option -->
        <!-- <div
          class="account-view-sidebar-option"
          :style="`padding-right: ${$vuetify.breakpoint.smAndUp ? 16 : 0}px;`"
        >
          <v-icon class="color-white-09 mr-1" :small="$vuetify.breakpoint.smAndUp">api</v-icon>
          <TText
            v-if="$vuetify.breakpoint.smAndUp"
            value="TAKT.integration"
            font_weight="400"
            medium
          />
        </div>
      </TFlex> -->

    </template>
    <template #content>
      <router-view/>
    </template>
  </TFinderLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { TFinderLayoutMixin } from '@/mixins/TFinderLayout.mixin.js';
import store from '@/store/index';
import TText from '@/components/Taktify/TText.component.vue';
import ToggleCapsule from '@/components/WorkPackageWIP/ToggleCapsule.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';

export default {
  name: 'Account',

  components: {
    TText,
    ToggleCapsule,
    StandardBadge,
  },

  mixins: [
    TFinderLayoutMixin,
  ],

  data: () => ({
  }),

  created() {
    store.dispatch('User/requestUserProjectInvites', store.getters['Auth/getUser'].id);
  },

  computed: {
    ...mapGetters('Auth', [
      'hasPermission'
    ]),

    ...mapGetters('User',[
      'getProjectInvites'
    ]),

    ...mapGetters('View',[
      'getUseOnSite'
    ]),
  },

  methods: {
    ...mapActions('View', [
      'setValue',
    ]),

    changeValue(variable, desc) {
        localStorage.setItem(desc.replaceAll(' ', '_'), !this.$store.state.View[variable]);
        this.setValue({key: variable, value: !this.$store.state.View[variable]});
    },
  }
}
</script>

<style lang="scss" scoped>
.account-view-actionbar {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 0 32px;
  align-items: center;
  grid-gap: 8px;
}
.account-view-sidebar-highlight {
  margin-left: -10px;
  height: 24px;
  width: 2px;
  position: absolute;
  background-color: rgba(255,255,255,0.9);
}
.account-view-sidebar-option {
  position: relative;
  display: flex;
}
</style>
